import React from "react";
import { SOURCE_PROPS } from './source_const.jsx';
import MapboxHelpTooltip from "../component/MapboxHelpTooltip.jsx";
import Select from "../../../../common/Select.jsx";
import ToggleSwitch from "../../../../common/ToggleSwitch.jsx";

const GeojsonTypeSetting = ({updateField, sourceField, index}) => {
    const geojson = sourceField.geojson || {};

    const {cluster, clusterMaxZoom, clusterRadius, data} = SOURCE_PROPS.geojson;
    return (
        <>
            <label className='col-xs-12 col-md-12'>
                {data.title}
                <MapboxHelpTooltip description={data.description} />
                <input
                    value={geojson.data || data.default}
                    type='text'
                    className='form-control'
                    data-index={index}
                    onChange={(e) => updateField(`sourceFields.${index}.geojson.data`, e.target.value)}
                />
            </label>
            <label className='col-xs-12 col-md-12 d-flex'>
                <label className='mr-1' style={{alignItems: 'center'}} >
                    {cluster.title}
                    <MapboxHelpTooltip description={cluster.description} />
                </label>
                <ToggleSwitch 
                isOn={geojson.cluster}
                defaultIsOn={cluster.default}
                name={`geocluster-${geojson.id}-${index}`}
                handleToggle={(e) => updateField(`sourceFields.${index}.geojson.cluster`, !geojson.cluster)}
                />
            </label>

            {
                geojson.cluster && 
                <>
                <label className='col-xs-6 col-md-6'>
                    {clusterMaxZoom.title}
                    <MapboxHelpTooltip description={clusterMaxZoom.description} />
                    <Select
                    value={geojson.clusterMaxZoom || clusterMaxZoom.default.toString()}
                    options={Array.from({length : clusterMaxZoom.max+1}, (v,index) => ({value: index, label: index}))}
                    onChange={(v) => updateField(`sourceFields.${index}.geojson.clusterMaxZoom`, v)}
                    />
                </label>
                <label className='col-xs-6 col-md-6'>
                    {clusterRadius.title}
                    <MapboxHelpTooltip description={clusterRadius.description} />
                    <input
                    value={geojson.clusterRadius || clusterRadius.default}
                    type='number'
                    className='form-control'
                    onChange={(e) => updateField(`sourceFields.${index}.geojson.clusterRadius`, e.target.value)}
                    />
                </label>
                </>
            }
        </>
    )
}

export default GeojsonTypeSetting;